<template>
  <InputWithMarketSpecificInfo
    :label-default="$t('Business entity')"
    :market="market"
    :text-default="textDefault"
    :text-markets="textMarkets"
    :title-default="$t('Why is this important?')"
  >
    <slot />
  </InputWithMarketSpecificInfo>
</template>

<script setup>
import InputWithMarketSpecificInfo from '@/components/inputs/InputWithMarketSpecificInfo.vue'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

defineProps({
  market: {
    type: String,
    default: null,
  },
})

const textDefault = $t(
  'Adding this information is crucial to ensure compliance from your first contract. If you have a business entity, its details will appear on your individual contracts and invoices. If you set up a new business, you can always add it to your Account settings later.',
)

const textMarkets = {
  UK: $t(
    'Adding this information is crucial to ensure compliance from the start. For example, if you have a Personal Service Company, Worksome will help determine your IR35 worker status for each contract, and the relevant details will appear on your agreement and invoices. If you set up a new business, you can always add it to your Account settings later.',
  ),
}
</script>
